//src/app/features/questionnaires/edit/TaxQuestionnaire/Income/SelfEmployment/fields.tsx
import { updateKeyInStore } from 'App';
import { store } from 'app/redux/store';
import * as Yup from 'yup';
import { requiredFiles } from '../../useValidateQuestionnaire';
import {
  SelfEmploymentStateValues,
  TSelfEmployment,
  updateFieldArrayKey,
  updateKey,
} from './slice';

export const fields: IBaseField<
  keyof SelfEmploymentStateValues | keyof TSelfEmployment
>[] = [
  {
    name: 'selfEmploymentList',
    label: 'Self Employment List',
    type: 'fieldArray',
    tooltip: '',
    comment: true,
    effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
    defaultDependency: {
      whoOwnsTheBusiness: null,
      areYouASubscribedBusinessWithAccountantsOnAir: null,
      doesAccountantsOnAirDoYourBookKeepingServices: null,
      currentOrPriorYearWhatBookKeepingSoftwareDidYouUse: null,
      whatIsTheBusinessStructure: null,
      pleaseGiveMoreDetails: null,
      typeOfBusiness: null,
      primaryServiceThatTheBusinessProvides: null,
      doesThisBusinessHaveATaxRegistrationNumber: null,
      businessName: null,
      businessAddress: null,
      haveYouFiledForm8858Or8832InThePast: null,
      grossIncomeFromSelfEmployment: null,
      currency: null,
      uploadDocumentShowingProofOfIncome: null,
      didYouPayPersonalIncomeTaxOnYourSelfEmploymentIncomeDuringTheYearCalendarTaxYearseparateFromSocialSecurity:
        null,
      amountOfPersonalIncomeTaxOnSelfEmploymentIncome: null,
      wasThisBusinessOperationalAtTheEndOfYear: null,
      doYouWantToListYourBusinessExpenses: null,
      ifYouHaveAnOrganizedbyCategoryExcelSheetWithExpensesPleaseUpload: null,
      doYouHaveAutoExpenses: null,
      isYourOfficeBasedOutOfYourHome: null,
      otherIncome: null,
      inventoryAtTheBeginningOfTheYear: null,
      inventoryAtTheEndOfTheYear: null,
      amountOfPurchasesLessTheCostOfItemsUsedForPersonalUse: null,
      costOfLabordoNotIncludeSalaryPaidToYourself: null,
      materialsAndSupplies: null,
      otherCosts: null,
      advertising: null,
      depreciationAndSection179ExpenseDeductionprovideDepreciationSchedules:
        null,
      commissionsAndFees: null,
      insuranceotherThanHealth: null,
      interestPaidToBanks: null,
      legalAndProfessionalServices: null,
      officeExpense: null,
      vehiclesMachineryAndEquipment: null,
      otherBusinessProperty: null,
      repairsAndMaintenance: null,
      supplies: null,
      travel: null,
      mealsAndEntertainment: null,
      selfEmploymentHealthInsurancePremium: null,
      wagesPaidToYourEmployees: null,
      otherExpenses: null,
      isThisAUSBusinessOrNonUS: null,
      pleaseUploadTheBusinessRegistrationDocumentFromTheNonUSCountry: null,
      taxRegistrationNumber: null,
      didYouMakeContributionsToASocialSecuritySystemInYourCountryOfResidenceDuringYear:
        null,
      pleaseProvideTheReason: null,
      pleaseExplain: null,
      autoExpensesAreFrequentlyAuditedDoYouHaveEvidenceToSupportYourDeduction:
        null,
      carAndTruckExpenses: null,
      whenDidYouPlaceYourVehicleInServiceForBusinessPurpuses: null,
      numberOfMilesUsedOverTheYearForBusiness: null,
      numberOfMilesUsedOverTheYearForOtherPurposes: null,
      wasYourVehicleAvailableForPersonalUseOffDutyHours: null,
      didYouOrYourSpouseHaveAnotherVehicleForPersonalUse: null,
    },
    dependencies: [
      {
        name: 'whoOwnsTheBusiness',
        label: 'Who owns the business?',
        type: 'select',
        options: [
          {
            label: 'Taxpayer',
            value: 'Taxpayer',
          },
          {
            label: 'Spouse',
            value: 'Spouse',
          },
          {
            label: 'Joint',
            value: 'Joint',
          },
        ],
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'areYouASubscribedBusinessWithAccountantsOnAir',
        label: 'Are you a Subscribed Business with Accountants On Air?',
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'doesAccountantsOnAirDoYourBookKeepingServices',
            label: 'Does Accountants On Air do your Bookkeeping Services?',
            type: 'radio',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            dependencies: [
              {
                name: 'currentOrPriorYearWhatBookKeepingSoftwareDidYouUse',
                label:
                  'Current or prior year, what bookkeeping software did you use?',
                type: 'select',
                options: [
                  {
                    label: 'Oracle Netsuite',
                    value: 'Oracle Netsuite',
                  },
                  {
                    label: 'Quickbooks',
                    value: 'Quickbooks',
                  },
                  {
                    label: 'Xero',
                    value: 'Xero',
                  },
                  {
                    label: 'Wave',
                    value: 'Wave',
                  },
                  {
                    label: 'Excel',
                    value: 'Excel',
                  },
                  {
                    label: 'Other Software',
                    value: 'Other Software',
                  },
                ],
                predicate: (value) => value === 'no',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
              },
            ],
          },
        ],
      },
      {
        name: 'whatIsTheBusinessStructure',
        label: 'What is the business structure?',
        subLabel: () => <p>Important to identify filing requirements</p>,
        type: 'select',
        options: [
          {
            label: 'Sole Propietorship',
            value: 'Sole Propietorship',
          },
          {
            label: 'Limited Liability Company',
            value: 'Limited Liability Company',
          },
          {
            label: 'Partnership',
            value: 'Partnership',
          },
          {
            label: 'Other',
            value: 'Other',
          },
        ],
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'pleaseGiveMoreDetails',
            label: 'Please give more details',
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'Other',
            placeholder: 'Enter',
          },
        ],
      },
      {
        name: 'typeOfBusiness',
        label: 'Type of business',
        type: 'select',
        options: [
          {
            label: 'Service - no inventory',
            value: 'Service - no inventory',
          },
          {
            label: 'Service - with inventory',
            value: 'Service - with inventory',
          },
          {
            label: 'Manufacturing',
            value: 'Manufacturing',
          },
        ],
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'primaryServiceThatTheBusinessProvides',
        label: 'Primary service that the business provides',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter',
      },
      {
        name: 'isThisAUSBusinessOrNonUS',
        label: 'Is this a US business or non-US?',
        type: 'radio',
        options: [
          { label: 'US Business', value: 'US Business' },
          { label: 'Non-US Business', value: 'Non-US Business' },
        ],
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'pleaseUploadTheBusinessRegistrationDocumentFromTheNonUSCountry',
            label:
              'Please upload the business registration document from the non-US country',
            type: 'upload',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'doesThisBusinessHaveATaxRegistrationNumber',
        label: 'Does this business have a tax registration number?',
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'taxRegistrationNumber',
            label: 'Tax Registration Number',
            subLabel: () => (
              <p>
                If possible, link to company registration; ex: Companies House
                (UK), Unternehmensregister (DE), Zefix (CH)
              </p>
            ),
            type: 'text',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
            placeholder: 'Enter',
          },
        ],
      },
      {
        name: 'businessName',
        label: 'Business Name',
        type: 'text',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter',
      },
      {
        name: 'businessAddress',
        label: 'Business Address',
        subLabel: () => (
          <p>If business run out of home, you can leave it blank</p>
        ),
        type: 'textarea',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        placeholder: 'Enter',
      },
      {
        name: 'haveYouFiledForm8858Or8832InThePast',
        label:
          'Have you filed form 8858 Foreign Disregard entity or 8832 C corporation Election?',
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'grossIncomeFromSelfEmployment',
        label: 'Gross income from Self Employment',
        type: 'currency',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'uploadDocumentShowingProofOfIncome',
        label: 'Upload document showing proof of income',
        type: 'upload',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'didYouPayPersonalIncomeTaxOnYourSelfEmploymentIncomeDuringTheYearCalendarTaxYearseparateFromSocialSecurity',
        label:
          'Did you pay personal income tax on your self-employment income during the selected year (separate from Social Security)?',
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            name: 'amountOfPersonalIncomeTaxOnSelfEmploymentIncome',
            label: 'How much did you pay?',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
        ],
      },
      {
        name: 'wasThisBusinessOperationalAtTheEndOfYear',
        label: 'Was this business operational at the end of the selected year?',
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
      },
      {
        name: 'doYouWantToListYourBusinessExpenses',
        label: 'Do you want to list your business expenses?',
        subLabel: () => (
          <p>
            Itemized expenses are necessary if you do not have your own
            bookkeeping system or a bookkeeping subscription with AOA.
          </p>
        ),
        type: 'radio',
        tooltip: '',
        comment: true,
        effect: updateKeyInStore(updateKey),
        dependencies: [
          {
            dependenciesTitle: 'Expenses',
            name: 'ifYouHaveAnOrganizedbyCategoryExcelSheetWithExpensesPleaseUpload',
            label:
              'If you have an organized (by category) excel sheet with expenses, please upload',
            type: 'upload',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
          },
          {
            name: 'doYouHaveAutoExpenses',
            label: 'Do you have auto expenses?',
            type: 'radio',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            predicate: (value) => value === 'yes',
            dependencies: [
              {
                dependenciesTitle: 'Auto Expenses',
                name: 'autoExpensesAreFrequentlyAuditedDoYouHaveEvidenceToSupportYourDeduction',
                label:
                  'Auto expenses are frequently audited - do you have evidence to support your deduction?',
                subLabel: () => (
                  <p>This category is frequently audited by the IRS</p>
                ),
                type: 'radio',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                predicate: (value) => value === 'yes',
                dependencies: [
                  {
                    name: 'carAndTruckExpenses',
                    label: 'Car and truck expenses',
                    subLabel: () => (
                      <p>Please complete the Auto Expense Schedule below</p>
                    ),
                    type: 'currency',
                    tooltip: '',
                    comment: true,
                    effect: updateKeyInStore(updateKey),
                    predicate: (value) => value === 'yes',
                  },
                  {
                    name: 'whenDidYouPlaceYourVehicleInServiceForBusinessPurpuses',
                    label:
                      'When did you place your vehicle in service for business purpuses?',
                    type: 'date',
                    tooltip: '',
                    comment: true,
                    effect: updateKeyInStore(updateKey),
                    predicate: (value) => value === 'yes',
                    placeholder: 'Select Date',
                  },
                  {
                    name: 'numberOfMilesUsedOverTheYearForBusiness',
                    label: 'Number of miles used over the year for business',
                    type: 'text',
                    tooltip: '',
                    comment: true,
                    effect: updateKeyInStore(updateKey),
                    predicate: (value) => value === 'yes',
                    placeholder: 'Enter',
                  },
                  {
                    name: 'numberOfMilesUsedOverTheYearForOtherPurposes',
                    label:
                      'Number of miles used over the year for other purposes',
                    type: 'text',
                    tooltip: '',
                    comment: true,
                    effect: updateKeyInStore(updateKey),
                    predicate: (value) => value === 'yes',
                    placeholder: 'Enter',
                  },
                  {
                    name: 'wasYourVehicleAvailableForPersonalUseOffDutyHours',
                    label:
                      'Was your vehicle available for personal use off-duty hours?',
                    type: 'radio',
                    tooltip: '',
                    comment: true,
                    effect: updateKeyInStore(updateKey),
                    predicate: (value) => value === 'yes',
                  },
                  {
                    name: 'didYouOrYourSpouseHaveAnotherVehicleForPersonalUse',
                    label:
                      'Did you (or your spouse) have another vehicle for personal use?',
                    type: 'radio',
                    tooltip: '',
                    comment: true,
                    effect: updateKeyInStore(updateKey),
                    predicate: (value) => value === 'yes',
                  },
                ],
              },
              {
                name: 'isYourOfficeBasedOutOfYourHome',
                label: 'Is your office based out of your home?',
                type: 'radio',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
                predicate: (value) => value === 'yes',
              },
              {
                name: 'otherIncome',
                label: 'Other Income',
                type: 'currency',
                predicate: (value) => value === 'yes',
                tooltip: '',
                comment: true,
                effect: updateKeyInStore(updateKey),
              },
            ],
          },

          {
            dependenciesTitle: 'Cost of Goods Sold',
            name: 'inventoryAtTheBeginningOfTheYear',
            label: 'inventory at the beginning of the year',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'inventoryAtTheEndOfTheYear',
            label: 'Inventory at the end of the year',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'amountOfPurchasesLessTheCostOfItemsUsedForPersonalUse',
            label:
              'Amount of Purchases, less the cost of items used for personal use',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'costOfLabordoNotIncludeSalaryPaidToYourself',
            label: 'Cost of labor (Do not include salary paid to yourself)',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'materialsAndSupplies',
            label: 'Materials and supplies',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'otherCosts',
            label: 'Other costs',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },

          {
            dependenciesTitle: 'Business Expenses',
            name: 'advertising',
            label: 'Advertising',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'depreciationAndSection179ExpenseDeductionprovideDepreciationSchedules',
            label:
              'Depreciation and section 179 expense deduction (provide depreciation schedules)',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'commissionsAndFees',
            label: 'Commissions and fees',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'insuranceotherThanHealth',
            label: 'Insurance (other than health)',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'interestPaidToBanks',
            label: 'Interest paid to banks',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'legalAndProfessionalServices',
            label: 'Legal and professional services',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'officeExpense',
            label: 'Office expense',
            subLabel: () => <p>if home office, see separate questions below</p>,
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'vehiclesMachineryAndEquipment',
            label: 'Vehicles, machinery, and equipment',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'otherBusinessProperty',
            label: 'Other business property',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'repairsAndMaintenance',
            label: 'Repairs and maintenance',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'supplies',
            label: 'Supplies',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'travel',
            label: 'Travel',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'mealsAndEntertainment',
            label: 'Meals and entertainment',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'selfEmploymentHealthInsurancePremium',
            label: 'Self-Employment Health Insurance Premium',
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'wagesPaidToYourEmployees',
            label: 'Wages paid to your employees',
            subLabel: () => <p>Enclose copies of Q-3/W-s forms if US staff</p>,
            type: 'currency',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
          },
          {
            name: 'otherExpenses',
            label: 'Other expenses',
            type: 'text',
            predicate: (value) => value === 'yes',
            tooltip: '',
            comment: true,
            effect: updateKeyInStore(updateKey),
            placeholder: 'Enter',
          },
        ],
      },
    ],
  },
];
const schema = requiredFiles(fields);
export const validationSchema = Yup.object().shape(requiredFiles(fields));
